module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ChangeBgImgView.js"));
	}, "ChangeBgImgView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ChangeBgImgView!./src/pages/PunchClock/ChangeBgImg/ChangeBgImgView.js
// module id = 1252
// module chunks = 438